<template>
  <div class="vertical-animation">
    <VerticalImage :animation="animation" :background="background" :loop="loop" />
  </div>
</template>

<script>
import VerticalImage from '@/components/VerticalImage.vue'

export default {
  name: 'vertical-orange',
  props: ['animation', 'background', 'loop'],
  components: {
    VerticalImage
  }
}
</script>

<style lang="scss" scoped>

.vertical-animation {
  height: 100%;
  width: 100%;
  z-index: 1;
}

</style>
